import type {JSX} from 'react';

import BenchlingConfig from 'BenchlingConfig';

/** Whether Agents product surfaces are enabled (interaction with existing agents, not creation). */
export function useIsRoutineServiceAccountUiEnabled(): boolean {
  return BenchlingConfig.LLM_ENABLE_AGENTS;
}

export interface RoutineServiceAccountUiEnabledRenderProps {
  isRoutineServiceAccountUiEnabled: boolean;
}

/** Supplies {@link useIsRoutineServiceAccountUiEnabled} to class components and other non-hook call sites. */
export function GetRoutineServiceAccountUiEnabled({
  children,
}: {
  children: (props: RoutineServiceAccountUiEnabledRenderProps) => JSX.Element;
}): JSX.Element {
  const isRoutineServiceAccountUiEnabled = useIsRoutineServiceAccountUiEnabled();
  return children({isRoutineServiceAccountUiEnabled});
}
